var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-group', {
    attrs: {
      "color": "primary"
    },
    on: {
      "change": _vm.setActive
    },
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, [_c('draggable', {
    attrs: {
      "handle": ".list-side__handle",
      "draggable": ".list-side__item"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.items,
      callback: function ($$v) {
        _vm.items = $$v;
      },
      expression: "items"
    }
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-list-item', {
      key: `${item.tempId}-item`,
      staticClass: "list-side__item",
      attrs: {
        "value": item.tempId
      }
    }, [_c('v-list-item-icon', {
      staticClass: "list-side__handle",
      staticStyle: {
        "cursor": "grab"
      }
    }, [_c('v-icon', [_vm._v("mdi-drag")])], 1), _c('v-list-item-title', [_vm._v(" " + _vm._s(item.term) + " ")]), item.tempId == _vm.selected ? _c('v-list-item-action', [_c('v-layout', {
      staticClass: "mr-8 my-n4",
      staticStyle: {
        "gap": "4px"
      }
    }, [!_vm.mobile ? _c('v-btn', {
      attrs: {
        "x-small": "",
        "icon": ""
      },
      on: {
        "click": _vm.edit
      }
    }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _vm._e(), _c('v-btn', {
      attrs: {
        "x-small": "",
        "icon": ""
      },
      on: {
        "click": _vm.pull
      }
    }, [_c('v-icon', [_vm._v("mdi-trash-can")])], 1)], 1)], 1) : _vm._e()], 1)];
  })], 2)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }